module.exports = __webpack_public_path__ + "static/cat2-tutor-screen-812a9a6f30e2d73c7e4c0932b38d69c6.png";